import { render, staticRenderFns } from "./PokemonSwiper.vue?vue&type=template&id=13890367&scoped=true"
import script from "./PokemonSwiper.vue?vue&type=script&lang=js"
export * from "./PokemonSwiper.vue?vue&type=script&lang=js"
import style0 from "./PokemonSwiper.vue?vue&type=style&index=0&id=13890367&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13890367",
  null
  
)

export default component.exports